import { Controller } from "@hotwired/stimulus";

// Gets the ID of something from a select dropdown, and uses it to redirect to a new page
export default class extends Controller {
  static values = { path: String, selectName: String };

  submitForm(event) {
    event.preventDefault();
    const selectedOption = this.element.querySelector(`select[name='${this.selectNameValue}'] option:checked`);

    // Default behavior: replace 'uuid' with the selected item's uuid in order to redirect to a path with the uuid. The uuid should be the selected option's value.
    const uuid = selectedOption.value;

    // Add any additional data attributes here for more custom paths. You will also need to add the data attributes to your select field's options. See amendment_select_options in prep_for_show.rb for an example.
    const dataOptions = {
      "proposal_uuid": selectedOption.dataset.proposal,
      "purchase_order_uuid": selectedOption.dataset.purchaseOrder
    };

    if (!selectedOption || !uuid) {
      // alert("Required data is missing. Please select a valid option.");
      $('.modal_alert').text('Please select a valid option before proceeding').addClass('alert alert-danger').fadeIn().fadeOut(3000);
      return;
    }

    let url = this.pathValue;

    // Replace placeholders from the url dynamically if matching keys exist in dataOptions
    Object.keys(dataOptions).forEach((key) => {
      if (dataOptions[key]) {
        url = url.replace(key, dataOptions[key]);
      }
    });

    url = url.replace("uuid", uuid);
    window.location.href = url;
  }
}
